import React from "react";
import { Skeleton } from "stories/Admin";

const JamatPageSkeleton: React.FC = () => (
  <div
    aria-busy="true"
    aria-label="Henter jamat-tider"
    style={{ display: "flex", flexDirection: "column", gap: 14 }}
  >
    {Array.from({ length: 7 }, (_, index) => (
      <div
        key={index}
        style={{
          display: "grid",
          gridTemplateColumns: "120px repeat(5, 86px) 1fr",
          gap: 24,
          alignItems: "center",
        }}
      >
        <Skeleton height={16} width={80} />
        {Array.from({ length: 5 }, (_, i) => (
          <Skeleton key={i} height={38} radius={12} />
        ))}
        <Skeleton height={32} width={110} radius={10} />
      </div>
    ))}
  </div>
);

export default JamatPageSkeleton;
